import { useAppContext } from "../stores/index.js";
export const useClientBrand = () => {
    const { state: { clientSettings: { brand }, }, } = useAppContext();
    return brand;
};
//# sourceMappingURL=useClientBrand.js.map